import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Beast Mode",
  date: new Date(2025, 4, 25),
  img: "/img/beast.jpeg",
  tracks: [
    {
      title: "Sum Of Parts",
      src: "/songs/2025-05-25/sum_of_parts.mp3",
      duration: 461.16,
    },
    {
      title: "Optimized Prize",
      src: "/songs/2025-05-25/optimized_prize.mp3",
      duration: 827.088,
    },
    {
      title: "Butterylicious",
      src: "/songs/2025-05-25/butterylicious.mp3",
      duration: 618.12,
    },
    {
      title: "Very Thin Sticks",
      src: "/songs/2025-05-25/very_thin_sticks.mp3",
      duration: 639.192,
    },
    {
      title: "Heroine Addict",
      src: "/songs/2025-05-25/heroine_addict.mp3",
      duration: 1033.728,
    },
    {
      title: "Spring Salmon Run",
      src: "/songs/2025-05-25/spring_salmon_run.mp3",
      duration: 751.08,
    },
    {
      title: "Dog Martins",
      src: "/songs/2025-05-25/dog_martins.mp3",
      duration: 763.056,
    },
    {
      title: "Wispering Loudly",
      src: "/songs/2025-05-25/wispering_loudly.mp3",
      duration: 919.056,
    },
    {
      title: "Signs In Your Face",
      src: "/songs/2025-05-25/signs_in_your_face.mp3",
      duration: 822.288,
    },
    {
      title: "Take 'Em On A Journey",
      src: "/songs/2025-05-25/take_em_on_a_journey.mp3",
      duration: 1812.576,
    },
    {
      title: "Roll One Up",
      src: "/songs/2025-05-25/roll_one_up.mp3",
      duration: 464.136,
    },
    {
      title: "Magician Musicians",
      src: "/songs/2025-05-25/magician_musicians.mp3",
      duration: 1247.616,
    },
    {
      title: "Endless Machine",
      src: "/songs/2025-05-25/endless_machine.mp3",
      duration: 997.752,
    },
    {
      title: "Trip To Pleasantville",
      src: "/songs/2025-05-25/trip_to_pleasantville.mp3",
      duration: 1086.48,
    },
  ],
};
export default album;
